const BLOCK_OPTIONS = [
  { key: 'emailData', label: 'Email data', description: 'Metadata and the email body' },
  { key: 'performance', label: 'Performance', description: 'Delivery, open, click and reply rates' },
  { key: 'recipients', label: 'Recipients', description: 'Grid of who the email was sent to' },
];

export const DEFAULT_EMAIL_BLOCKS = { emailData: true, performance: false, recipients: false };

const EmailCampaignBlocksPicker = ({ emailBlocks, setEmailBlocks }) => {
  const toggleBlock = (key) => {
    const isLastChecked = emailBlocks[key] && Object.values(emailBlocks).filter(Boolean).length === 1;
    if (isLastChecked) return;
    setEmailBlocks({ ...emailBlocks, [key]: !emailBlocks[key] });
  };

  return (
    <div>
      {BLOCK_OPTIONS.map(({ key, label, description }) => (
        <div className='checkbox-item' key={key}>
          <input
            id={`email-campaign-block-${key}`}
            type='checkbox'
            checked={!!emailBlocks[key]}
            onChange={() => toggleBlock(key)}
          />
          <label
            htmlFor={`email-campaign-block-${key}`}
            className='font-weight-normal specific-top-margin-2'
            style={{ display: 'inline-block' }}
          >
            <p className='mb-2 mt-0'>{label}</p>
            <p className='mb-0 paragraph-p2 light-50-text'>{description}</p>
          </label>
        </div>
      ))}
    </div>
  );
};

export default EmailCampaignBlocksPicker;
